// -----------------
// Consultant Pages
// -----------------
import Login from './components/Login.vue'
import ResetPassword from './components/ResetPassword.vue'
import Profile from './components/Profile.vue'
import Tutorials from './components/Tutorials.vue'
import Tutorial from './components/Tutorial.vue'
import CreatePage from './components/CreatePage.vue'
import CreateGroup from './components/CreateGroup.vue'
import CreateGroupMembers from './components/CreateGroupMembers.vue'
import CreateGroupSurvey from './components/CreateGroupSurvey.vue'
import CreateGroupSurveyDetails from './components/CreateGroupSurveyDetails.vue'
import CreateGroupSurveyEmailSettings from './components/CreateGroupSurveyEmailSettings.vue'
import CreateGroupSurveyDates from './components/CreateGroupSurveyDates.vue'
import CreateGroupSurveyLaunch from './components/CreateGroupSurveyLaunch.vue'
import GroupPage from './components/GroupPage.vue'
import GroupSurveyPage from './components/GroupSurveyPage.vue'
import GroupSurveyReport from './components/GroupSurveyReport.vue'
import ContactGroupMembers from './components/ContactGroupMembers.vue'
import ConsultantMaterials from './components/ConsultantMaterials.vue'
import TOTMaterials from './components/TOTMaterials.vue'
import AdminMaterials from './components/AdminMaterials.vue'
import FAQ from './components/FAQ.vue'
import AggregatedReports from './components/AggregatedReports.vue'
import Checklist from './components/Checklist.vue'
import PriceCalculation from './components/PriceCalculation.vue'
import LearningHub from './components/LearningHub.vue'
import LearningCourse from './components/LearningCourse'
import LearningExam from './components/LearningExam'
import LearningModule from './components/LearningModule'
import LearningStep from './components/LearningStep'
// -------------
// Public Pages
// -------------
import APIQuestionnaire from './components/APIQuestionnaire.vue'
import GDQQuestionnaire from './components/GDQQuestionnaire.vue'
import AddOnSurvey from './components/AddOnSurvey'
import MaintenanceMode from './components/MaintenanceMode'
import ConsultantMailPreferences from './components/ConsultantMailPreferences'
// Styleguide
import StyleGuide from './components/StyleGuide.vue'
import Dashboard from './components/Dashboard.vue'
import AllSurveys from './components/dashboard/AllSurveys.vue'
import AllReports from './components/dashboard/AllReports.vue'
import AllFoldersGroups from './components/dashboard/AllFoldersGroups.vue'
import TeamDashboard from './components/dashboard/TeamDashboard.vue'

// -------
// Routes
// -------
const routes = [
  // ------------------
  // Login and profile
  // ------------------
  {
    name: 'login',
    path: '/login',
    component: Login,
    meta: {
      breadCrumbs: [{
        to: 'login', text: 'Login'
      }]
    }
  },
  {
    name: 'resetpassword',
    path: '/resetpassword/:t',
    component: ResetPassword,
    meta: {
      breadCrumbs: [{
        to: 'resetpassword', text: 'Reset Password'
      }]
    }
  },
  {
    name: 'profile',
    path: '/profile',
    component: Profile,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/profile', text: 'Profile' }
      ]
    }
  },
  {
    name: 'consultantmaterials',
    path: '/consultantmaterials',
    component: ConsultantMaterials,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/consultantmaterials', text: 'Consultant Materials' }
      ]
    }
  },
  {
    name: 'faq',
    path: '/faq',
    component: FAQ,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/faq', text: 'FAQ' }
      ]
    }
  },
  {
    name: 'totmaterials',
    path: '/totmaterials',
    component: TOTMaterials,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/totmaterials', text: 'ToT Materials' }
      ]
    }
  },
  {
    name: 'adminmaterials',
    path: '/adminmaterials',
    component: AdminMaterials,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/adminmaterials', text: 'Admin Materials' }
      ]
    }
  },
  {
    name: 'tutorials',
    path: '/tutorials',
    component: Tutorials,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/tutorials', text: 'Tutorials' }
      ]
    }
  },
  {
    name: 'tutorial',
    path: '/tutorial',
    component: Tutorial,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/tutorials', text: 'Tutorials' },
        { to: '/tutorial', text: 'Tutorial' }
      ]
    }
  },
  {
    name: 'pricecalculation',
    path: '/pricecalculation',
    component: PriceCalculation,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/pricecalculation', text: 'Offer' }
      ]
    }
  },
  // ------------------
  // My GDQ Management
  // ------------------
  {
    name: 'dashboard',
    path: '/',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'Dashboard' }
      ]
    }
  },
  // All surveys/folders/reports
  {
    name: 'allsurveys',
    path: '/surveys',
    component: AllSurveys,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/surveys', text: 'My surveys' }
      ]
    }
  },
  {
    name: 'allreports',
    path: '/reports',
    component: AllReports,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My reports' },
        { to: '/reports', text: 'My reports' }
      ]
    }
  },
  {
    name: 'allgroupsfolders',
    path: '/foldersgroups',
    component: AllFoldersGroups,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My folders & groups' },
        { to: '/foldersgroups', text: 'My folders & groups' }
      ]
    }
  },
  // Checklist
  {
    name: 'checklist',
    path: '/checklist',
    component: Checklist,
    meta: {}
  },
  // ---------------
  // Create Process
  // ---------------
  {
    name: 'createpage',
    path: '/create',
    component: CreatePage,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/create', text: 'Create' }
      ]
    }
  },
  {
    name: 'creategroup',
    path: '/create/group',
    component: CreateGroup,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/create', text: 'Create' },
        { to: '/create/group', text: 'Create Group' }
      ]
    }
  },
  {
    name: 'creategroupmembers',
    path: '/create/group/members',
    component: CreateGroupMembers,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/create', text: 'Create' },
        { to: '/create/group', text: 'Create Group' },
        { to: '/create/group/members', text: 'Create Group Members' }
      ]
    }
  },
  {
    name: 'creategroupsurvey',
    path: '/create/group/survey',
    component: CreateGroupSurvey,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/create', text: 'Create' },
        { to: '/create/group', text: 'Create Group' },
        { to: '/create/group/survey', text: 'Create Group Survey' }
      ]
    }
  },
  {
    name: 'creategroupsurveydetails',
    path: '/create/group/survey/details',
    component: CreateGroupSurveyDetails,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/create', text: 'Create' },
        { to: '/create/group', text: 'Create Group' },
        { to: '/create/group/survey', text: 'Create Group Survey' },
        { to: '/create/group/survey/details', text: 'Create Group Survey Details' }
      ]
    }
  },
  {
    name: 'creategroupsurveyemailsettings',
    path: '/create/group/survey/emailsettings',
    component: CreateGroupSurveyEmailSettings,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/create', text: 'Create' },
        { to: '/create/group', text: 'Create Group' },
        { to: '/create/group/survey', text: 'Create Group Survey' },
        { to: '/create/group/survey/emailsettings', text: 'Survey E-mail Settings' }
      ]
    }
  },
  {
    name: 'creategroupsurveydates',
    path: '/create/group/survey/dates',
    component: CreateGroupSurveyDates,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/create', text: 'Create' },
        { to: '/create/group', text: 'Create Group' },
        { to: '/create/group/survey', text: 'Create Group Survey' },
        { to: '/create/group/survey/dates', text: 'Survey Date Settings' }
      ]
    }
  },
  {
    name: 'creategroupsurveylaunch',
    path: '/create/group/survey/launch',
    component: CreateGroupSurveyLaunch,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/create', text: 'Create' },
        { to: '/create/group', text: 'Create Group' },
        { to: '/create/group/survey', text: 'Create Group Survey' },
        { to: '/create/group/survey/launch', text: 'Launch' }
      ]
    }
  },
  // ------------
  // Survey Page
  // ------------
  {
    name: 'groupsurveypage',
    path: '/group/survey',
    component: GroupSurveyPage,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/group', text: 'Group Page' },
        { to: '/group/survey', text: 'Group Survey Page' }
      ]
    }
  },
  {
    name: 'groupsurveyreport',
    path: '/group/survey/report',
    component: GroupSurveyReport,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/group', text: 'Group Page' },
        { to: '/group/survey', text: 'Group Survey Page' },
        { to: '/group/survey/reports', text: 'Group Survey Report' }
      ]
    }
  },
  {
    name: 'contactgroupmembers',
    path: '/group/survey/contact',
    component: ContactGroupMembers,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/group', text: 'Group Page' },
        { to: '/group/survey', text: 'Group Survey Page' },
        { to: '/group/survey/contact', text: 'Contact Group Members' }
      ]
    }
  },
  // -----------
  // Group Page
  // -----------
  {
    name: 'grouppage',
    path: '/group',
    component: GroupPage,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/group', text: 'Group Page' }
      ]
    }
  },
  {
    name: 'grouppagegroup',
    path: '/group/:id',
    component: GroupPage,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/group', text: 'Group Page' }
      ]
    }
  },
  {
    name: 'aggregatedreports',
    path: '/aggregatedreports',
    component: AggregatedReports,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/aggregatedreports', text: 'Aggregated Reports' }
      ]
    }
  },
  // ---------------
  // Team Dashboard
  // ---------------
  {
    name: 'teamdashboard',
    path: '/teamdashboard',
    component: TeamDashboard,
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/teamdashboard', text: 'My Teams' }
      ]
    }
  },
  // -------------
  // Learning Hub
  // -------------
  {
    name: 'learninghub',
    path: '/learninghub',
    component: LearningHub,
    meta: {
      navbar: true,
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/learninghub', text: 'Learning Hub' }
      ]
    }
  },
  // Learning course
  {
    name: 'elearningcourse',
    path: '/elearningcourse/:c?/:s?',
    component: LearningCourse,
    meta: {
      navbar: true,
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/learninghub', text: 'Learning Hub' },
        { to: '', text: 'Course' }
      ]
    }
  },
  // Learning module
  {
    name: 'elearningmodule',
    path: '/elearningmodule/:m',
    component: LearningModule,
    meta: {
      navbar: true,
      requiresAuth: true,
      breadCrumbs: [
        { to: '/', text: 'My GDQ Management' },
        { to: '/learninghub', text: 'Learning Hub' },
        { to: '/elearningcourse/:c?/:s?', text: 'Course' },
        { to: '/', text: 'Module' }
      ]
    }
  },
  // Learning exam
  {
    name: 'elearningexam',
    path: '/elearningexam/:c?',
    component: LearningExam,
    meta: {
      requiresAuth: true
    }
  },

  // Learning step
  {
    name: 'elearningstep',
    path: '/elearningstep/:s',
    component: LearningStep,
    meta: {
      navbar: true,
      requiresAuth: true
    }
  },
  // ----------
  // API Survey
  // ----------
  {
    name: 'apiquestionnaire',
    path: '/apiquestionnaire/:i/:t',
    component: APIQuestionnaire
  },
  // -------------------
  // Public Survey Form
  // -------------------
  {
    name: 'gdqquestionnaire',
    path: '/gdqquestionnaire/:t',
    component: GDQQuestionnaire
  },
  // -------------------
  // Public Survey Form
  // -------------------
  {
    name: 'addonsurvey',
    path: '/addonsurvey/:a/:m',
    component: AddOnSurvey
  },
  // Maintenance mode
  {
    name: 'maintenancemode',
    path: '/maintenancemode',
    component: MaintenanceMode
  },
  // Styleguide
  {
    name: 'styleguide',
    path: '/styleguide',
    component: StyleGuide,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'consultantmailpreferences',
    path: '/consultantmailpreferences/:t',
    component: ConsultantMailPreferences,
    meta: {
      requiresAuth: false
    }
  }
]
export default routes
